import Entity from '../entity'
import  Cliente  from '@/store/entities/OZONE/cliente';
export default class TransferenciaDash extends Entity<number>{
    total: number;
    pendientes: string;
    enviadas: object;
    emitidas: object;
    rechazadas: object;
    informacionCashback: Array<object>;
}